/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { environment } from '@rocksoft/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthorizationGuard {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);

  canMatch: CanMatchFn = (_route: Route, _segments: UrlSegment[]): Observable<boolean | UrlTree> => {
    const routeToRedirect = this.router.currentNavigation()?.extractedUrl.toString();
    if (!routeToRedirect) {
      return of(false);
    }

    return this.checkAuth(routeToRedirect);
  };

  canActivate: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> => {
    return this.checkAuth(state.url);
  };

  canActivateChild: CanActivateChildFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> => {
    return this.checkAuth(state.url);
  };

  private checkAuth(url: string): Observable<boolean | UrlTree> {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map(({ allConfigsAuthenticated }) => {
        // allow navigation if authenticated
        if (allConfigsAuthenticated.some((config) => config.isAuthenticated)) {
          return true;
        }

        // redirect if not authenticated
        sessionStorage.setItem('redirect', url);
        if (this.oidcSecurityService.getConfigurations().length === 1) {
          if (environment.oidc[0].domain_hint != null) {
            this.oidcSecurityService.authorize(this.oidcSecurityService.getConfigurations()[0].configId, {
              customParams: {
                domain_hint: environment.oidc[0].domain_hint,
              },
            });
          } else {
            this.oidcSecurityService.authorize(this.oidcSecurityService.getConfigurations()[0].configId);
          }

          return false;
        }

        return this.router.parseUrl('/login');
      })
    );
  }
}
